<template>
  <section id="contact" class="contact-section">
    <!-- Animated Background -->
    <div class="contact-bg"></div>
    <div class="floating-shapes">
      <div class="shape circle"></div>
      <div class="shape square"></div>
      <div class="shape triangle"></div>
      <div class="shape hexagon"></div>
    </div>

    <!-- Particle effect overlay -->
    <div class="particles">
      <div
        class="particle"
        v-for="i in 20"
        :key="i"
        :style="particleStyle(i)"
      ></div>
    </div>

    <v-container class="py-16 fill-height position-relative">
      <v-row align="center">
        <!-- Left Side -->
        <v-col
          cols="12"
          md="6"
          class="white--text text-center text-md-left"
          data-aos="fade-right"
        >
          <transition name="fade-slide">
            <div>
              <h2 class="contact-heading mb-6">
                Ready for Superior <br />
                <span class="highlight">Service Excellence?</span>
              </h2>

              <p class="contact-sub mb-10">
                Contact our corporate support team to discuss your service level
                agreement and property management needs.
              </p>
            </div>
          </transition>
        </v-col>

        <!-- Right Side -->
        <v-col cols="12" md="6" data-aos="fade-left">
          <transition name="fade-slide">
            <v-card elevation="8" class="contact-card pa-8">
              <h3 class="contact-title mb-6">
                <span class="title-text">Corporate Contacts</span>
              </h3>

              <v-list class="pa-0" style="background: transparent">
                <v-list-item
                  v-for="(item, index) in contactDetails"
                  :key="index"
                  class="px-0 mb-4 hover-item"
                  :style="{ animationDelay: `${index * 0.1}s` }"
                >
                  <v-list-item-icon class="mr-4 icon-wrapper">
                    <v-icon color="#f46523" size="28" class="contact-icon">{{
                      item.icon
                    }}</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title
                      class="font-weight-bold mb-1 item-title"
                      style="color: black"
                    >
                      {{ item.title }}
                    </v-list-item-title>
                    <v-list-item-subtitle
                      class="item-subtitle"
                      style="color: #666"
                    >
                      {{ item.subtitle }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <div class="hover-indicator"></div>
                </v-list-item>
              </v-list>
            </v-card>
          </transition>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
export default {
  name: "ContactSection",
  data() {
    return {
      contactDetails: [
        {
          icon: "mdi-map-marker",
          title: "Corporate Office",
          subtitle: "1645 S River Rd, Unit 3,Des Plaines,IL 60018, USA",
        },
        {
          icon: "mdi-phone",
          title: "Business Line",
          subtitle: "+1 708-295-3912",
        },
        {
          icon: "mdi-email",
          title: "Email",
          subtitle: " support@ohyesworld.com",
        },
      ],
    };
  },
  methods: {
    openContact() {
      this.$emit("open-contact");
    },
    particleStyle() {
      return {
        left: `${Math.random() * 100}%`,
        animationDelay: `${Math.random() * 5}s`,
        animationDuration: `${5 + Math.random() * 10}s`,
      };
    },
  },
  mounted() {
    if (window.AOS) {
      window.AOS.init({ duration: 1000, once: true });
    }
  },
};
</script>

<style scoped>
.contact-section {
  position: relative;
  min-height: 100vh;
  background: white;
  overflow: hidden;
  display: flex;
  align-items: center;
}

.contact-bg {
  position: absolute;
  inset: 0;
  background: url("https://images.unsplash.com/photo-1497366216548-37526070297c?w=1600&q=80")
    center/cover no-repeat;
  opacity: 0.12;
  transform: scale(1.1);
  filter: brightness(70%);
  z-index: 0;
  animation: bgPulse 20s ease-in-out infinite;
}

@keyframes bgPulse {
  0%,
  100% {
    transform: scale(1.1);
  }
  50% {
    transform: scale(1.15);
  }
}

/* Enhanced Floating Shapes */
.floating-shapes {
  position: absolute;
  inset: 0;
  overflow: hidden;
  z-index: 1;
}

.shape {
  position: absolute;
  opacity: 0.15;
  animation: float 8s ease-in-out infinite;
  filter: blur(1px);
  transition: opacity 0.3s ease;
}

.shape:hover {
  opacity: 0.25;
}

.circle {
  width: 120px;
  height: 120px;
  background: radial-gradient(circle, #f46523, #ff8c42);
  border-radius: 50%;
  top: 10%;
  left: 5%;
  animation: float 8s ease-in-out infinite, pulse 3s ease-in-out infinite;
}

.square {
  width: 100px;
  height: 100px;
  background: linear-gradient(45deg, #f46523, #ff8c42);
  top: 70%;
  left: 80%;
  animation: float 10s ease-in-out infinite, rotate 15s linear infinite;
  transform: rotate(25deg);
}

.triangle {
  width: 0;
  height: 0;
  border-left: 60px solid transparent;
  border-right: 60px solid transparent;
  border-bottom: 100px solid #f46523;
  top: 30%;
  left: 75%;
  opacity: 0.1;
  animation: float 12s ease-in-out infinite;
  animation-delay: 2s;
}

.hexagon {
  width: 80px;
  height: 140px;
  background: #f46523;
  clip-path: polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%);
  top: 50%;
  left: 10%;
  opacity: 0.12;
  animation: float 9s ease-in-out infinite;
  animation-delay: 3s;
}

@keyframes float {
  0%,
  100% {
    transform: translateY(0) rotate(0deg);
  }
  50% {
    transform: translateY(-30px) rotate(10deg);
  }
}

@keyframes pulse {
  0%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* Particle Effect */
.particles {
  position: absolute;
  inset: 0;
  z-index: 1;
  pointer-events: none;
}

.particle {
  position: absolute;
  width: 3px;
  height: 3px;
  background: #f46523;
  border-radius: 50%;
  opacity: 0;
  animation: particleFloat 10s ease-in-out infinite;
}

@keyframes particleFloat {
  0% {
    transform: translateY(100vh) scale(0);
    opacity: 0;
  }
  10% {
    opacity: 0.6;
  }
  90% {
    opacity: 0.6;
  }
  100% {
    transform: translateY(-100vh) scale(1);
    opacity: 0;
  }
}

/* Typography Animations */
.contact-heading {
  font-size: clamp(2rem, 4vw, 3.5rem);
  color: black;
  line-height: 1.2;
  font-weight: 700;
  animation: fadeInUp 1s ease-out;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.highlight {
  color: #f46523;
  display: inline-block;
  position: relative;
}

@keyframes highlightGlow {
  0%,
  100% {
    text-shadow: 0 0 10px rgba(244, 101, 35, 0.5);
  }
  50% {
    text-shadow: 0 0 20px rgba(244, 101, 35, 0.8);
  }
}

.contact-sub {
  color: black;
  font-weight: 300;
  line-height: 1.6;
  margin-inline: auto;
  animation: fadeInUp 1s ease-out 0.2s backwards;
}

/* Enhanced Button */
.glow-btn {
  position: relative;
  overflow: hidden;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 15px rgba(244, 101, 35, 0.3);
  animation: fadeInUp 1s ease-out 0.4s backwards;
}

.glow-btn::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  transform: translate(-50%, -50%);
  transition: width 0.6s, height 0.6s;
}

.glow-btn:hover::before {
  width: 300px;
  height: 300px;
}

.glow-btn:hover {
  box-shadow: 0 0 30px rgba(244, 101, 35, 0.8),
    0 8px 25px rgba(244, 101, 35, 0.4);
  transform: translateY(-3px);
}

.glow-btn:active {
  transform: translateY(-1px);
}

.btn-text {
  position: relative;
  z-index: 1;
}

.arrow-icon {
  position: relative;
  z-index: 1;
  transition: transform 0.3s ease;
}

.glow-btn:hover .arrow-icon {
  transform: translateX(5px);
}

/* Enhanced Card */
.contact-card {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(15px);
  border-radius: 12px;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  border: 1px solid rgba(244, 101, 35, 0.1);
  animation: fadeInLeft 1s ease-out;
}

@keyframes fadeInLeft {
  from {
    opacity: 0;
    transform: translateX(50px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.contact-card:hover {
  transform: translateY(-8px) scale(1.02);
  box-shadow: 0 20px 40px rgba(244, 101, 35, 0.25);
  border-color: rgba(244, 101, 35, 0.3);
}

.contact-title {
  color: black;
  border-left: 4px solid #f46523;
  padding-left: 16px;
  font-weight: 600;
  position: relative;
  overflow: hidden;
}

.title-text {
  display: inline-block;
  animation: slideInRight 0.6s ease-out;
}

@keyframes slideInRight {
  from {
    transform: translateX(-20px);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

/* Enhanced List Items */
.hover-item {
  position: relative;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border-radius: 8px;
  cursor: pointer;
  animation: fadeIn 0.6s ease-out backwards;
  overflow: hidden;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.hover-item::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 3px;
  background: #f46523;
  transform: scaleY(0);
  transition: transform 0.3s ease;
}

.hover-item:hover::before {
  transform: scaleY(1);
}

.hover-item:hover {
  background: linear-gradient(90deg, rgba(244, 101, 35, 0.08), transparent);
  transform: translateX(10px);
  padding-left: 12px;
}

.hover-indicator {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%) translateX(10px);
  width: 6px;
  height: 6px;
  background: #f46523;
  border-radius: 50%;
  opacity: 0;
  transition: all 0.3s ease;
}

.hover-item:hover .hover-indicator {
  opacity: 1;
  transform: translateY(-50%) translateX(0);
}

.icon-wrapper {
  transition: transform 0.3s ease;
}

.hover-item:hover .icon-wrapper {
  transform: rotate(360deg) scale(1.2);
}

.contact-icon {
  transition: all 0.3s ease;
  filter: drop-shadow(0 0 0 transparent);
}

.hover-item:hover .contact-icon {
  filter: drop-shadow(0 0 8px rgba(244, 101, 35, 0.6));
}

.item-title {
  transition: all 0.3s ease;
}

.hover-item:hover .item-title {
  color: #f46523 !important;
  transform: translateX(5px);
}

.item-subtitle {
  transition: all 0.3s ease;
}

.hover-item:hover .item-subtitle {
  color: #333 !important;
  transform: translateX(5px);
}

/* Fade-slide transitions */
.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: all 0.8s cubic-bezier(0.4, 0, 0.2, 1);
}

.fade-slide-enter {
  opacity: 0;
  transform: translateY(30px);
}

.fade-slide-leave-to {
  opacity: 0;
  transform: translateY(-30px);
}

/* Responsive adjustments */
@media (max-width: 960px) {
  .contact-heading {
    text-align: center;
  }

  .contact-sub {
    text-align: center;
  }

  .glow-btn {
    width: 100%;
  }
}
</style>
